export function withPattern(
  value: string | null | undefined,
  pattern: RegExp
): boolean {
  return value !== null && value !== undefined && pattern.test(value);
}

// Example usage:
// const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// console.log(withPattern('test@example.com', pattern)); // true
// console.log(withPattern('invalid-email', pattern)); // false
